import { Identifiable, Event } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByResources(
  event: Identifiable<Event>,
  { resources }: Filter,
) {
  return (
    !!resources &&
    resources.length > 0 &&
    !resources.find((resource) =>
      (event.participants || []).find(({ uuid }) => resource.uuid === uuid),
    )
  );
}

export { isFilteredByResources };
